import {ReactElement, useMemo} from "react";
import {RendererProps} from "../RendererProps";
import {Account} from "../../../../../contexts/chartofaccounts/ChartOfAccountsContext";
import {ensureNotObject, formatYearAndVersionType, keyify} from "../common";
import {RenderPendingUpdates} from "./RenderPendingUpdates";
import * as common from "../styles/common.module.scss";

export interface RenderSetPropertyDriversProps extends RendererProps {
    accounts: Account[];
    operationalMetricTypes: {id: string, name: string}[];
}

export function RenderSetPropertyDrivers(props: RenderSetPropertyDriversProps): ReactElement {
    const accountMap = useMemo(() => {
        return props.accounts.toIdMap(a => a.id);
    }, [props.accounts]);

    const year = props.variables["year"];
    const versionType = props.variables["versionType"];
    const accountDrivers = props.variables["items"];

    const accountRenders: ReactElement[] = [];
    if(Array.isArray(accountDrivers) && accountDrivers.length > 0) {
        for(const accountInfo of accountDrivers) {
            if(typeof accountInfo !== "object" || accountInfo === null) {
                continue;
            }

            const accountId = accountInfo["accountId"];
            const account = accountMap[accountId];
            const accountName = account?.name ?? "Unknown";

            const pendingUpdates = accountInfo["pendingUpdates"];

            accountRenders.push(<div key={keyify(accountId)}>
                <div className={common.textSubHeader}>{ensureNotObject(accountName)}</div>
                <div>
                    {typeof pendingUpdates === "object" && pendingUpdates !== null &&
                        <RenderPendingUpdates accounts={props.accounts} operationalMetricTypes={props.operationalMetricTypes} pendingUpdates={pendingUpdates} />
                    }
                </div>
            </div>);
        }
    }

    return <div>
        <div className={common.textHeader}>{formatYearAndVersionType(year, versionType)}</div>
        {accountRenders}
    </div>;
}